<template>
    <section class="agencies">
        <div class="flex">
            <div id="agencies">
                <input v-model="search" type="text" placeholder="Search..." class="agency-search" />

                <div class="list-wrapper" :style="`height: ${mapDimensions.listingHeight}px;`">
                    <div v-for="(agency, index) in agencies" :key="agency.id">
                        <div
                            v-if="passesSearch(agency) && visibleMarkers.includes(index)"
                            :ref="`agency-${index}`"
                            class="agency"
                            :class="{active: focusedAgency == index}"
                            @click="focusAgency(index)"
                        >
                            <div class="flex">
                                <div class="icon">
                                    <i class="fas fa-map-marker-alt"></i>
                                </div>
                                <div class="text">
                                    <h3>{{ agency.name }}</h3>
                                    <p v-html="agency.address.join('<br />')"></p>
                                    <p class="link">
                                        <a :href="`/agencies/${agency.id}`">View Details</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="map" :style="`height: ${mapDimensions.height}; width: ${mapDimensions.width}`"></div>
        </div>
    </section>
</template>

<script>
import {Loader} from '@googlemaps/js-api-loader';

export default {
    props: {
        agencies: {type: Array, required: true},
        mapHeight: {type: String, default: ''},
        mapWidth: {type: String, default: ''},
    },

    data() {
        return {
            search: '',
            map: null,
            markers: [],
            visibleMarkers: [],
            focusedAgency: null,
        };
    },

    computed: {
        mapDimensions() {
            return {
                height: this.mapHeight,
                width: this.mapWidth,
                listingHeight: this.mapHeight.replace(/\D/g, '') - 115,
            };
        },
    },

    watch: {
        search() {
            this.markers.forEach((marker, index) => {
                marker.setMap(this.passesSearch(this.agencies[index]) ? this.map : null);
            });
            this.showVisibleMarkers();
        },
    },

    mounted() {
        this.renderMap();
    },

    methods: {
        renderMap() {
            const agencies = this.agencies.filter(agency => agency.coordinates);
            const loader = new Loader({
                apiKey: 'AIzaSyC8CQkol-lGStZowzYD9DgI_BKotW_FE3A',
                version: 'weekly',
            });
            loader.load().then(() => {
                const uluru = {lat: 38.0902, lng: -95.7129};
                this.map = new google.maps.Map(document.getElementById('map'), {
                    zoom: 4,
                    center: uluru,
                    fullscreenControl: 0,
                });
                const bounds = new google.maps.LatLngBounds();
                agencies.forEach(agency => {
                    const marker = this.addToMap(agency);
                    const loc = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
                    bounds.extend(loc);
                });

                this.map.fitBounds(bounds);
                this.map.panToBounds(bounds);

                google.maps.event.addListener(this.map, 'idle', () => {
                    this.showVisibleMarkers();
                });
            });
        },

        addToMap(agency) {
            const marker = new google.maps.Marker({
                position: agency.coordinates,
                map: this.map,
                title: agency.name,
                id: agency.id,
            });

            this.markers.push(marker);

            marker.addListener('click', () => {
                const index = this.markers.indexOf(marker);
                this.$refs[`agency-${index}`][0].scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'start',
                });
                this.focusAgency(index);
            });

            return marker;
        },

        focusAgency(index) {
            const markerPosition = this.markers[index].getPosition();
            this.map.panTo(markerPosition);
            this.markers[index].setAnimation(google.maps.Animation.BOUNCE);
            setTimeout(() => this.markers[index].setAnimation(null), 700);
            this.focusedAgency = index;
        },

        showVisibleMarkers() {
            this.visibleMarkers = [];
            this.markers.forEach((marker, index) => {
                if (this.map.getBounds().contains(this.markers[index].getPosition())) {
                    this.visibleMarkers.push(index);
                }
            });
        },

        passesSearch(agency) {
            const search = this.search.trim().toLowerCase();

            if (search.length < 3) {
                return true;
            }

            return !search || agency.name.toLowerCase().includes(search);
        },
    },
};
</script>
